import $ from "jquery";
import Rails from "rails-ujs";
import "init";

window.jQuery = $;
Rails.start();
